module.exports = __webpack_public_path__ + "static/media/error-circle-fill.4277578f.svg";